import { Component, OnInit, inject, input } from "@angular/core";
import RecallHistoryTableItem from "@models/recallHistoryTableItem";
import RejectHistoryTableItem from "@models/rejectHistoryTableItem";
import ReopenHistoryTableItem from "@models/reopenHistoryTableItem";
import LocalApplicationRoleService from "@services/local-application_role.service";
import LocalContractUserService from "@services/local-contractUser.service";
import {
  IPRFIDocumentDownload,
  IPRFIItem,
} from "src/app/api-generated";

@Component({
  selector: "rfiLogTab",
  templateUrl: "./rfiLogTab.component.html",
  styleUrls: ["./rfiLogTab.component.scss"],
  standalone: false
})
export default class RFILogTabComponent implements OnInit {
  localContractUserService = inject(LocalContractUserService);
  localApplicationRoleService = inject(LocalApplicationRoleService);

  readonly entity = input<IPRFIItem>(undefined);

  readonly docs = input<IPRFIDocumentDownload[]>(undefined);

  rejectHistory: RejectHistoryTableItem[] = [];

  recallHistory: RecallHistoryTableItem[] = [];

  reopenHistory: ReopenHistoryTableItem[] = [];

  ngOnInit(): void {
    const entity = this.entity();
    if (entity.rfi_reject_detail && entity.rfi_reject_detail.length > 0) {
      const rejects = [
        ...entity.rfi_reject_detail
          .sort(
            (a, b) =>
              new Date(a.DateUpdated).getTime() -
              new Date(b.DateUpdated).getTime(),
          )
      ];
      this.rejectHistory = rejects.map((r, i)=>{
        return new RejectHistoryTableItem(r, this.localContractUserService, i);
      });
    }
    if (entity.rfi_recall?.length > 0 && entity.rfi_flow?.length > 0) {
      const flows = [
        ...entity.rfi_flow
          .sort(
            (a, b) =>
              new Date(a.DateReceived).getTime() -
              new Date(b.DateReceived).getTime(),
          )
      ];
      const recalls = [
        ...entity.rfi_recall
          .sort(
            (a, b) =>
              new Date(a.DateUpdated).getTime() -
              new Date(b.DateUpdated).getTime(),
          )
      ];
      if(entity.IsRecalled) {
        recalls.splice(-1);
      }
      this.recallHistory = recalls.map((r, i)=>{
        return new RecallHistoryTableItem(r, this.localContractUserService, flows, i);
      });
    }
    if(entity.rfi_reopen?.length > 0)
    {
      const reopens = [
        ...entity.rfi_reopen
          //.filter((reopen)=>{return reopen.Approved !== null})
          .sort(
            (a, b) =>
              new Date(a.DateRequest).getTime() -
              new Date(b.DateRequest).getTime(),
          )
      ];
      this.reopenHistory = reopens.map((r, i)=>{
        return new ReopenHistoryTableItem(r, this.entity(), this.docs(), this.localContractUserService, this.localApplicationRoleService, i);
      })
    }
  }

}
